/**
 * Initialize feature list
 *
 * @param {HTMLElement} root
 */
const BASE_CLASS = 'js-feature-list';

const init = (root) => {
	root.classList.add('initialized');

	const items = root.querySelectorAll(`.${BASE_CLASS}__item`);
	const snippets = root.querySelectorAll(`.${BASE_CLASS}__snippet`);

	const isSingleColumn = root.classList.contains('m-feature-list--column-count-1');

	// Only show snippets for single column feature lists
	if (!isSingleColumn) {
		return;
	}

	// Function to scroll to an element with a specific class and offset
	function scrollToElement(selector, offset) {
		const element = document.querySelector(selector);
		if (element) {
			const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
			const offsetPosition = elementPosition - offset;
			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth',
			});
		}
	}

	let headerHeight = document.querySelector('.js-header').offsetHeight;
	let scrollOffset = headerHeight + 48;

	// Add event listener for window resize
	window.addEventListener('resize', () => {
		headerHeight = document.querySelector('.js-header').offsetHeight;
		scrollOffset = headerHeight + 48;
	});

	const activateItem = (item) => {
		items.forEach((currentItem) => currentItem.classList.toggle('active', currentItem === item));
		snippets.forEach((snippet) => {
			const isActive = snippet.dataset.id === item.dataset.id;
			snippet.classList.toggle('active', isActive);
			if (!isActive || snippet.style.display === 'none') {
				return;
			}
			let blockTop = snippet.getBoundingClientRect().top;
			if (window.innerWidth < 1024) {
				let activeSnippetMobile = snippet.closest('.js-feature-list__item.active');
				// scroll to the top of active item on mobile
				if (activeSnippetMobile) {
					activeSnippetMobile.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			} else {
				// scroll to the top of active snippet (desktop) - (header and submenu height)
				window.scrollBy({ top: blockTop - scrollOffset, left: 0, behavior: 'smooth' });
			}
		});
	};

	items.forEach((item) => {
		item.addEventListener('click', (event) => {
			const isMobileLink =
				event.target.closest('.js-feature-list__snippet a.js-feature-list__mobile-link') !== null;

			if (!isMobileLink) {
				event.preventDefault();
				activateItem(item);
			}
		});
	});
};

export const initFeatureList = (root = document) => {
	const featureLists = root.querySelectorAll(`.${BASE_CLASS}:not(.initialized)`);
	Array.from(featureLists).forEach((root) => {
		init(root);
	});
};
